import * as z from "zod/v4";

export const getSkioIntegration = {
  name: "getSkioIntegration" as const,
  input: z.null(),
  output: z.object({ exists: z.boolean(), apiKey: z.string().optional() }),
};
